export default [
  {
    name: 'Benutzer',
    icon: 'ti-user',
    path: '/users'
  },
  {
    name: 'Tipprunden',
    icon: 'ti-cup',
    path: '/betgames'
  },
  {
    name: 'Logout',
    icon: 'ti-control-eject',
    path: '/logout'
  }
]



// WEBPACK FOOTER //
// ./src/bgsidebarLinks.js